import React from 'react';
import { ActionsContainer, ActionSpacer } from './HBPopover.styles';
import HBButton from '../HBButton/HBButton';
import { TTextAlignment } from '../HBText/HBText.types';
import { HBPopoverAction } from './HBPopover';
import { useWindowSize } from '../../hooks/useWindowSize';

interface IHBPopoverProps {
    actions: HBPopoverAction[];
    actionsAlignment?: TTextAlignment;
    clickCallback?: (newIsOpen, triggeredFrom) => void;
    marginTop?: number;
    actionsOrientation?: 'horizontal' | 'vertical';
}

const HBPopoverActions = ({
    actions,
    actionsAlignment,
    clickCallback,
    marginTop = 0,
    actionsOrientation
}: IHBPopoverProps) => {
    const { isUpToSmall } = useWindowSize();

    const isVerticalActions = actionsOrientation === 'vertical';
    return (
        <ActionsContainer
            $actionsAlignment={actionsAlignment}
            $marginTop={marginTop}
            $isVertical={isVerticalActions}
        >
            {actions.map(action => (
                <ActionSpacer key={action.text} $isVertical={isVerticalActions}>
                    <HBButton
                        size={isUpToSmall ? 'lg' : 'xs'}
                        fullWidth
                        buttonTheme={action.theme}
                        {...action}
                        onClick={e => {
                            action.onClick(e, clickCallback);
                        }}
                        disabled={action.disabled}
                        testId={
                            action.testIdName
                                ? `hb-popover-${action.testIdName}-option--button`
                                : undefined
                        }
                        testIdType="hb-popover-option--button"
                    >
                        {action.text}
                    </HBButton>
                </ActionSpacer>
            ))}
        </ActionsContainer>
    );
};

export default HBPopoverActions;
